module.exports = __webpack_public_path__ + "img/wa-not-hover.3a9566dc.png";